import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import axios from 'axios';
import Select from 'react-select';
import AddBoardModal from './AddBoard/AddBoard';
import AddColumnModal from './AddBoard/AddColumnModal';
import AddAutoMation from './Automation/Automation';
import Automations from './Automation/Automations';
import services from '../services';
import { boardLocal } from '../utils/LocalSt';
import { useSelector } from 'react-redux';
import { HiArchiveBox } from 'react-icons/hi2';
import { toast } from 'react-toastify';
import ConfirmationPopup from './ConfirmationPopup';
import { useDispatch } from 'react-redux';
import { changeBoradTab, setEmailStatus, setWhatsAppStatus, toggleDate, toggleTable } from '../Redux/slice';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Notification from './notification/Notification';
import { getAllDateTableTask } from '../Redux/GetSlice';
import { Button, Menu, MenuItem, Tooltip } from '@mui/material';
import AllAutomation from './Automation/AllAutomation';
import { useClickAway } from "react-use";
import { PrivilegesViewChecker, PrivilegesChecker } from '../utils/PrivilegesChecker';
import { getLocalStorageItem, setLocalStorageItem } from '../utils/Localstorage/localStorageUtils';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import AddIcon from '@mui/icons-material/Add';
import { CreateLabelDialog } from '../common/CreateLabelDialog'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
const Header = ({
    filterList,
    emailName,
    handleChange,
    handleSelectedBoard,
    setSelectedBoardId,
    handleAddColumn,
    selectedBoardId,
    selectedEmailsIds,
    role,
    setSelectedBoard,
    selectedBoard,
    getTaskMailIndbox,
    columns,
    getAllBoard,
    boardName,
    setBoardName,
    getTaskMail,
    activeButton,
    setActiveButton,
    setTaskMail,
    filters,
    setFilters,
    fetchAllData,
    userList = []
}) => {
    const [boardStatus, setBoardStatus] = useState(false);
    const [columnAddStatus, setColumnAddStatus] = useState(false);
    const [deleteShowBox, setDeleteShowBox] = useState(false);
    const [automtStatus, setAutomtStatus] = useState(false);
    const [deleteItem, setDeleteItem] = useState('');
    const navigate = useNavigate();
    const [hasArchiveAccess, setHasArchiveAccess] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const dispatch = useDispatch();
    const selectedTab = useSelector((state) => state?.redux?.selectedTab);
    const columnCall = useSelector((state) => state.redux.AddColumnCall);
    const tabMapping = {
        GMAIL: 0,
        GMAIL_BOARD: 1,
        WHATSAPP: 2,
    };
    const [open, setOpen] = React.useState(false);

    const valueTab = tabMapping[selectedTab] ?? 0;
    const [step, setStep] = useState(1);
    const [editId, setEditId] = useState(null);
    const [isOpenDeadline, setIsOpenDeadline] = useState(false);
    const deadlineDropdownRef = useRef(null);
    const [showFilters, setShowFilters] = useState(() => sessionStorage.getItem('kanbanFiltersOpen') === 'true');
    const [filterFieldOpenIndex, setFilterFieldOpenIndex] = useState(null);
    const filterFieldDropdownRef = useRef(null);
    const [assigneeOpenIndex, setAssigneeOpenIndex] = useState(null);
    const assigneeDropdownRef = useRef(null);
    const filterRef = useRef(null);
    const [searchTermAssignee, setSearchTermAssignee] = useState('');
    const [properties, setProperties] = useState([]);
    const [propertyOpenIndex, setPropertyOpenIndex] = useState(null);
    const propertyDropdownRef = useRef(null);
    const [searchTermProperty, setSearchTermProperty] = useState('');
    const [localFilterValues, setLocalFilterValues] = useState({});

    // Sync local values with global filters when they change externally
    useEffect(() => {
        const values = {};
        filters.forEach((f, i) => {
            if (f.field !== 'user.name') {
                values[i] = f.value;
            }
        });
        setLocalFilterValues(values);
    }, [filters]);

    const handleFilterKeyDown = (e, index) => {
        if (e.key === 'Enter') {
            updateFilter(index, { value: localFilterValues[index] || '' });
        }
    };

    const handleFilterBlur = (index) => {
        updateFilter(index, { value: localFilterValues[index] || '' });
    };

    const location = useLocation();
    const isLabel = location?.state?.isLabel;

    // Build user options from the userList prop
    const userOptions = userList.map((u) => ({
        label: u.name || u.email || `User ${u.id}`,
        value: u.id,
    }));

    const propertyOptions = (Array.isArray(properties) ? properties : []).map((p) => ({
        label: p?.property?.propertyName || p?.name || 'Unnamed Property',
        value: p?.property?.id || p?.propertyId || p?.id,
    }));

    useEffect(() => {
        const fetchProperties = async () => {
            if (selectedBoardId) {
                try {
                    const res = await services.property.GET_PROPERTY_BY_BOARD_ID(selectedBoardId);
                    setProperties(res?.data?.data || (Array.isArray(res?.data) ? res.data : []));
                } catch (error) {
                    console.error("Error fetching properties:", error);
                    setProperties([]);
                }
            }
        };
        fetchProperties();
    }, [selectedBoardId]);

    // Close property dropdown on outside click
    useEffect(() => {
        if (propertyOpenIndex === null) return;
        function handleOutsideClick(e) {
            if (propertyDropdownRef.current && !propertyDropdownRef.current.contains(e.target)) {
                setPropertyOpenIndex(null);
                setSearchTermProperty('');
            }
        }
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [propertyOpenIndex]);

    // Close filter-field custom dropdown on outside click
    useEffect(() => {
        if (filterFieldOpenIndex === null) return;
        function handleOutsideClick(e) {
            if (filterFieldDropdownRef.current && !filterFieldDropdownRef.current.contains(e.target)) {
                setFilterFieldOpenIndex(null);
            }
        }
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [filterFieldOpenIndex]);

    // Close assignee dropdown on outside click
    useEffect(() => {
        if (assigneeOpenIndex === null) return;
        function handleOutsideClick(e) {
            if (assigneeDropdownRef.current && !assigneeDropdownRef.current.contains(e.target)) {
                setAssigneeOpenIndex(null);
                setSearchTermAssignee('');
            }
        }
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [assigneeOpenIndex]);

    const toggleAssigneeUser = (index, user) => {
        const currentVal = Array.isArray(filters[index]?.value) ? filters[index].value : [];
        const exists = currentVal.find((u) => u.value === user.value);
        const newVal = exists
            ? currentVal.filter((u) => u.value !== user.value)
            : [...currentVal, user];
        updateFilter(index, { value: newVal });
    };

    const toggleProperty = (index, property) => {
        const currentVal = Array.isArray(filters[index]?.value) ? filters[index].value : [];
        const exists = currentVal.find((p) => p.value === property.value);
        const newVal = exists
            ? currentVal.filter((p) => p.value !== property.value)
            : [...currentVal, property];
        updateFilter(index, { value: newVal });
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setShowFilters(false);
            }
        }
        if (showFilters) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFilters, setShowFilters]);

    useEffect(() => {
        sessionStorage.setItem('kanbanFiltersOpen', showFilters ? 'true' : 'false');
    }, [showFilters]);

    const handleClick = (button) => {
        setActiveButton(button);
        if (button === 'board') {
            navigate('/app');
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));

        } else if (button === 'date') {
            const data = {
                boardId: selectedBoardId,
            };

            dispatch(getAllDateTableTask({ data }));
            dispatch(toggleDate(true));
            dispatch(toggleTable(false));
        } else if (button === 'table') {
            dispatch(toggleTable(true));
            dispatch(toggleDate(false));
        }
    };
    const handleUser = () => {
        navigate('/user');
    };

    const [isLogoutUser, setIsLogoutUser] = useState(false);
    const [automations, setAutomations] = useState(false);
    const privileges = ["Add Gmail Account", "Add whatsapp Account", "Board Management", "Create automation"];

    const showMenuButton = privileges.some(p => PrivilegesViewChecker(p));


    const getButtonClass = (button) =>
        `view-toggle-btn ${activeButton === button ? 'active' : ''}`;

    const filterdropdown = () => {
        setIsOpenDeadline(!isOpenDeadline);
    };

    const settingsBtnRef = useRef(null);
    const [settingsDropdownPos, setSettingsDropdownPos] = useState({ top: 50, right: 23 });

    const logoutdropdown = () => {
        if (!isLogoutUser && settingsBtnRef.current) {
            const rect = settingsBtnRef.current.getBoundingClientRect();
            setSettingsDropdownPos({
                top: rect.bottom + 8,
                right: Math.max(8, window.innerWidth - rect.right),
            });
        }
        setIsLogoutUser(!isLogoutUser);
    };

    const handleAutomation = () => { };
    const addFilter = () => {
        setFilters([...filters, { field: '', operator: '', value: '' }]);
    };

    const removeFilter = (index) => {
        const remaining = filters.filter((_, i) => i !== index);
        setFilters(remaining);
        setLocalFilterValues((prev) => {
            const next = {};
            Object.keys(prev)
                .map(Number)
                .filter((i) => i !== index)
                .forEach((i) => {
                    next[i > index ? i - 1 : i] = prev[i];
                });
            return next;
        });
        getTaskMail(1, { filtersOverride: remaining });
    };

    const resetFilters = () => {
        const cleared = [{ field: '', operator: '', value: '' }];
        setFilters(cleared);
        setLocalFilterValues({});
        getTaskMail(1, { filtersOverride: cleared });
    };

    const applyFilters = () => {
        const mergedFilters = filters.map((f, i) =>
            f.field !== 'user.name' && Object.prototype.hasOwnProperty.call(localFilterValues, i)
                ? { ...f, value: localFilterValues[i] || '' }
                : f
        );
        setFilters(mergedFilters);
        getTaskMail(1, { filtersOverride: mergedFilters });
    };

    const hasActiveFilter = filters.some(
        (f) => f.field && (Array.isArray(f.value) ? f.value.length > 0 : !!f.value)
    );

    const updateFilter = (index, updates) => {
        const newFilters = filters.map((f, i) =>
            i === index ? { ...f, ...updates } : f
        );
        setFilters(newFilters);
    };
    const userDataRaw = getLocalStorageItem("userData");
    let userData;
    if (typeof userDataRaw === "string") {
        try {
            userData = JSON.parse(userDataRaw);
        } catch {
            userData = null;
        }
    } else {
        userData = userDataRaw;
    }

    const userDataRef = useRef(userData);
    useEffect(() => {
        userDataRef.current = userData;
    }, [userData]);
    useEffect(() => {
        const userData = getLocalStorageItem('userData');

        if (typeof userData === 'string') {
            const parsedData = JSON.parse(userData);
            if (role === 'admin' && !parsedData?.isPermission) {
                setHasArchiveAccess(true);
            } else if (parsedData?.isPermission) {
                setHasArchiveAccess(true);
            }
        } else if (userData && userData.isPermission) {
            if (role === 'admin' && !userData?.isPermission) {
                setHasArchiveAccess(true);
            } else if (userData?.isPermission) {
                setHasArchiveAccess(true);
            }
        }
        if (columnCall) setColumnAddStatus(false);
    }, [columnCall, boardName, role]);


    const handleDelete = async () => {
        try {
            await services.board.DELETE_BOARD(deleteItem);
            toast.success('Board Delete Successfully...');
            setDeleteItem('');
            setDeleteShowBox(false);
            getAllBoard();
        } catch (error) {
            console.error(error);
        }
    };
    const handleChangeTab = (event, newValue) => {
        let tab = 'GMAIL';

        if (newValue === 0) {
            tab = 'GMAIL';
        } else if (newValue === 2) {
            tab = 'WHATSAPP';
        } else if (newValue === 1) {
            tab = 'GMAIL_BOARD';
        }

        dispatch(changeBoradTab(tab));
    };


    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleSelect = (type) => {
        if (type === 'gmail') {
            dispatch(setEmailStatus(true));
        } else if (type === 'whatsapp') {
            dispatch(setWhatsAppStatus(true));
        }
        handleCloseMenu();
    };

    useEffect(() => {
        if (!isOpenDeadline) return;
        function handleClickOutside(event) {
            if (deadlineDropdownRef.current && !deadlineDropdownRef.current.contains(event.target)) {
                setIsOpenDeadline(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenDeadline]);


    useEffect(() => {
        if (activeButton == "board") {
            navigate('/app')
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));
            if (selectedBoardId) {
                getTaskMail(1, {}, selectedBoardId)

            }
        }
        if (isLabel) {
            setActiveButton("label")
        }

    }, [activeButton, selectedBoardId])


    return (
        <>
            <div className="header-app flex justify-between items-stretch">
                {(PrivilegesViewChecker("gmail") || PrivilegesViewChecker("whatsapp")) && activeButton !== 'label' && (
                    <>
                        <div style={{ display: 'flex', minWidth: '300px', maxWidth: '358px', height: '100%' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'stretch',
                                    height: '100%',
                                }}
                            >
                                {activeButton !== 'sent' && activeButton !== 'all-mail' && (
                                    <div className="w-[359px] flex items-stretch luxe-booking-tabs luxe-booking-tabs--plain">
                                        {(PrivilegesViewChecker("gmail")) && (
                                            <div
                                                className={`header-tab-item create-booking-tab ${valueTab === 0 ? 'active is-active' : ''}`}
                                                onClick={(e) => handleChangeTab(e, 0)}
                                            >
                                                Gmail
                                            </div>
                                        )}
                                        {(PrivilegesViewChecker("gmail")) && (
                                            <div
                                                className={`header-tab-item create-booking-tab ${valueTab === 1 ? 'active is-active' : ''}`}
                                                onClick={(e) => handleChangeTab(e, 1)}
                                            >
                                                Gmail Board
                                            </div>
                                        )}
                                        {(PrivilegesViewChecker("whatsapp")) && (
                                            <div
                                                className={`header-tab-item create-booking-tab ${valueTab === 2 ? 'active is-active' : ''}`}
                                                onClick={(e) => handleChangeTab(e, 2)}
                                            >
                                                Whatsapp
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
                {activeButton === 'label' && (<>
                    <div style={{ display: 'flex', minWidth: '350px', maxWidth: '458px', justifyContent: 'space-between', alignSelf: 'center', padding: '0 12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <LabelOutlinedIcon style={{ fontSize: '18px', color: '#01579B' }} />
                            <span style={{ fontSize: '14px', fontWeight: 600, color: '#1f2937' }}>Labels</span>
                        </div>
                        {PrivilegesChecker("labels") && (
                            <div onClick={() => setOpen(true)} className='cursor-pointer settings-btn' title="Create Label" style={{ width: '28px', height: '28px', borderRadius: '7px' }}>
                                <AddIcon style={{ fontSize: '16px' }} />
                            </div>
                        )}
                        <CreateLabelDialog open={open} setOpen={setOpen} getAllBoard={getAllBoard} fetchAllData={fetchAllData} />
                    </div>
                </>)}


                <div className="header-item flex items-center justify-center" style={{ flex: 1, gap: '16px', alignSelf: 'center' }}>
                    <div className="view-toggle-group">
                        {role == 'admin' || (boardName && boardName.length > 0 && selectedBoard) ? (
                            <>
                                <div onClick={() => handleClick('board')} className={getButtonClass('board')}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="13"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-filter-right rotate-[0deg]"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5m0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5m0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5" />
                                    </svg>
                                    <span>Board</span>
                                </div>
                                <div onClick={() => handleClick('table')} className={getButtonClass('table')}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-calendar2-range"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                        <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zM9 8a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1m-8 2h4a1 1 0 1 1 0 2H1z" />
                                    </svg>
                                    <span>Table</span>
                                </div>
                                <div onClick={() => handleClick('date')} className={getButtonClass('date')}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-calendar3-event"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                        <path d="M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                    </svg>
                                    <span>Date</span>
                                </div>
                                {PrivilegesViewChecker("labels") ? (
                                    <>
                                        <div onClick={() => handleClick('label')} className={getButtonClass('label')}>
                                            <LabelOutlinedIcon fontSize="small" />
                                            <span>Label</span>
                                        </div>
                                    </>
                                ) : (null)}
                                {PrivilegesViewChecker("All email") && <div onClick={() => handleClick('all-mail')} className={getButtonClass('all-mail')}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-envelope"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v.5l-8 5-8-5V4z" />
                                        <path d="M0 6.697v5.803a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6.697l-7.555 4.722a1 1 0 0 1-1.11 0L0 6.697z" />
                                    </svg>
                                    <span>All Emails</span>
                                </div>}
                            </>
                        ) : (
                            <div className="text-sm text-gray-500">No board assigned</div>
                        )}

                        <div className=" text-[black] flex items-center">
                            {isLogoutUser && createPortal(
                            <div onClick={logoutdropdown} className="block">
                                <div className="layout-backdrop"></div>
                                <div
                                    className="dropdown !fixed open deadline-day deadend-start-w move-bottom kanban-dropDown border-2 border-[#F5F5F5] text-black"
                                    style={{ right: settingsDropdownPos.right, top: settingsDropdownPos.top, zIndex: 9999, maxHeight: 'calc(100vh - 24px)', overflowY: 'auto' }}
                                >
                                    {PrivilegesViewChecker("Add Gmail Account") && <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => {
                                            handleSelect('gmail');
                                            setIsOpenDeadline(false);
                                        }}
                                    >
                                        <button className=" text-black text-[12px]"> Add gmail account</button>
                                    </div>}
                                    {PrivilegesViewChecker("Add whatsapp Account") && <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => {
                                            handleSelect('whatsapp');
                                            setIsOpenDeadline(false);
                                        }}
                                    >
                                        <button className=" text-black text-[12px]">Add whatsapp account</button>
                                    </div>}

                                    {PrivilegesViewChecker("add-board") && <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => {
                                            setBoardStatus(true);
                                            setIsOpenDeadline(false);
                                        }}
                                    >
                                        <button className=" text-black text-[12px]">Add Board</button>
                                    </div>}

                                    {PrivilegesViewChecker("emailtemplate") && <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => navigate('/template')}
                                    >
                                        <button className=" text-black text-[12px]">Template</button>
                                    </div>}
                                    {PrivilegesViewChecker("user-management") && <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                        onClick={() => navigate('/usermanage')}
                                    >
                                        <button className=" text-black text-[12px]">User management</button>
                                    </div>}
                                    {PrivilegesViewChecker("Board Management") && <div className="rounded-[4px] hover:bg-[#f3f3f3]">
                                        <button className=" text-black text-[12px]" onClick={() => navigate('/boardmanage')}>
                                            Board Management
                                        </button>
                                    </div>}

                                    {PrivilegesViewChecker("Create automation") && <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                    >
                                        <button
                                            onClick={() => setAutomations(!automations)}
                                            className=" text-black text-[12px]"
                                        >
                                            Add Automations
                                        </button>
                                    </div>}
                                    {(role === 'admin') && <div
                                        className="rounded-[4px] hover:bg-[#f3f3f3]"
                                    >
                                        <button
                                            onClick={() => navigate('/boardallocation')}
                                            className=" text-black text-[12px]"
                                        >
                                            Board Allocation
                                        </button>
                                    </div>}
                                </div>
                            </div>,
                            document.body
                            )}
                        </div>
                    </div>
                </div>


                {activeButton !== 'label' && activeButton !== 'sent' && activeButton !== "" && activeButton !== "all-mail" && (
                    <div className="d-flex" style={{ gap: '12px', alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
                        {(boardName && boardName.length > 0 && selectedBoard) ? (
                            <div onClick={() => setShowFilters(prev => !prev)} className="filters-btn relative">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    fill="currentColor"
                                    viewBox="0 0 512 512"
                                >
                                    <path d="M64 96h384v48H64zm80 136h224v48H144zm48 136h128v48H192z" />
                                </svg>
                                <span>Filters</span>
                                {hasActiveFilter && (
                                    <span
                                        style={{
                                            position: 'absolute',
                                            top: '2px',
                                            right: '2px',
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            background: '#22c55e',
                                            border: '1.5px solid #ffffff',
                                        }}
                                    />
                                )}
                            </div>
                        ) : (null)}
                        {showFilters && (
                            <div
                                ref={filterRef}
                                className="absolute z-50"
                                style={{
                                    top: '54px',
                                    right: '80px',
                                    minWidth: '400px',
                                    background: '#ffffff',
                                    borderRadius: '14px',
                                    border: '1.5px solid #e0e8e3',
                                    boxShadow: '0 8px 32px rgba(26,92,50,0.10), 0 2px 8px rgba(0,0,0,0.06)',
                                    padding: '18px 20px 16px',
                                }}
                            >
                                {/* Header */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#1A5C32" viewBox="0 0 512 512">
                                        <path d="M64 96h384v48H64zm80 136h224v48H144zm48 136h128v48H192z" />
                                    </svg>
                                    <span style={{ fontSize: '11px', fontWeight: 700, color: '#1A5C32', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Filters</span>
                                </div>

                                {/* Filter rows */}
                                {filters.map((filter, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>

                                        {/* Field selector — custom dropdown for green hover */}
                                        {(() => {
                                            const fieldOptions = [
                                                { value: '', label: 'Select field' },
                                                { value: 'task.title', label: 'Title' },
                                                { value: 'task.subject', label: 'Subject' },
                                                { value: 'task.name', label: 'Name' },
                                                { value: 'user.name', label: 'Assignee' },
                                                { value: 'customProperty', label: 'Property' },
                                            ];
                                            const selectedLabel = fieldOptions.find(o => o.value === filter.field)?.label || 'Select field';
                                            const isOpen = filterFieldOpenIndex === index;
                                            return (
                                                <div
                                                    ref={isOpen ? filterFieldDropdownRef : null}
                                                    style={{ position: 'relative', minWidth: '130px' }}
                                                >
                                                    <button
                                                        type="button"
                                                        onClick={() => setFilterFieldOpenIndex(isOpen ? null : index)}
                                                        style={{
                                                            width: '100%',
                                                            height: '34px',
                                                            padding: '0 28px 0 10px',
                                                            fontSize: '13px',
                                                            color: filter.field ? '#1f2937' : '#9ca3af',
                                                            border: `1.5px solid ${isOpen ? '#1a7d3e' : '#e0e8e3'}`,
                                                            borderRadius: '8px',
                                                            background: '#fafcfb',
                                                            outline: 'none',
                                                            cursor: 'pointer',
                                                            textAlign: 'left',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            boxShadow: isOpen ? '0 0 0 3px rgba(26,125,62,0.1)' : 'none',
                                                            transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
                                                        }}
                                                    >
                                                        <span>{selectedLabel}</span>
                                                        <svg style={{ position: 'absolute', right: '8px', flexShrink: 0, transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s ease' }} width="12" height="12" viewBox="0 0 16 16" fill="#6b7280">
                                                            <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                                        </svg>
                                                    </button>
                                                    {isOpen && (
                                                        <ul style={{
                                                            position: 'absolute',
                                                            top: '38px',
                                                            left: 0,
                                                            zIndex: 9999,
                                                            width: '100%',
                                                            background: '#fff',
                                                            border: '1.5px solid #e0e8e3',
                                                            borderRadius: '8px',
                                                            boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
                                                            padding: '4px 0',
                                                            margin: 0,
                                                            listStyle: 'none',
                                                        }}>
                                                            {fieldOptions.map(opt => (
                                                                <li
                                                                    key={opt.value}
                                                                    onClick={() => {
                                                                        const field = opt.value;
                                                                        const value = (field === 'user.name' || field === 'customProperty') ? [] : '';
                                                                        updateFilter(index, { field, value });
                                                                        setAssigneeOpenIndex(null);
                                                                        setSearchTermAssignee('');
                                                                        setPropertyOpenIndex(null);
                                                                        setSearchTermProperty('');
                                                                        setFilterFieldOpenIndex(null);
                                                                    }}
                                                                    style={{
                                                                        padding: '8px 12px',
                                                                        fontSize: '13px',
                                                                        cursor: 'pointer',
                                                                        color: filter.field === opt.value ? '#1a7d3e' : '#1f2937',
                                                                        background: filter.field === opt.value ? '#f0fdf4' : 'transparent',
                                                                        fontWeight: filter.field === opt.value ? 600 : 400,
                                                                        transition: 'background 0.12s ease',
                                                                    }}
                                                                    onMouseEnter={e => {
                                                                        if (filter.field !== opt.value) {
                                                                            e.currentTarget.style.background = '#f0fdf4';
                                                                            e.currentTarget.style.color = '#1a7d3e';
                                                                        }
                                                                    }}
                                                                    onMouseLeave={e => {
                                                                        if (filter.field !== opt.value) {
                                                                            e.currentTarget.style.background = 'transparent';
                                                                            e.currentTarget.style.color = '#1f2937';
                                                                        }
                                                                    }}
                                                                >
                                                                    {opt.label}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            );
                                        })()}

                                        <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: 500, flexShrink: 0 }}>is</span>

                                        {/* Value input — multi-select for Assignee, text for others */}
                                        {filter.field === 'user.name' ? (
                                            <div className="relative flex-1" ref={assigneeOpenIndex === index ? assigneeDropdownRef : null}>
                                                <button
                                                    type="button"
                                                    onClick={() => setAssigneeOpenIndex(assigneeOpenIndex === index ? null : index)}
                                                    style={{
                                                        width: '100%',
                                                        height: '34px',
                                                        padding: '0 10px',
                                                        fontSize: '13px',
                                                        border: '1.5px solid #e0e8e3',
                                                        borderRadius: '8px',
                                                        background: '#fafcfb',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        cursor: 'pointer',
                                                        minWidth: '160px',
                                                        transition: 'border-color 0.15s ease',
                                                    }}
                                                >
                                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: Array.isArray(filter.value) && filter.value.length > 0 ? '#1a7d3e' : '#9ca3af', fontWeight: Array.isArray(filter.value) && filter.value.length > 0 ? 500 : 400 }}>
                                                        {Array.isArray(filter.value) && filter.value.length > 0
                                                            ? filter.value.length === userOptions.length
                                                                ? 'All selected'
                                                                : `${filter.value.length} selected`
                                                            : 'Select assignees...'}
                                                    </span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="#9ca3af" viewBox="0 0 16 16" style={{ flexShrink: 0, marginLeft: '6px' }}>
                                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                    </svg>
                                                </button>

                                                {assigneeOpenIndex === index && (
                                                    <div
                                                        className="absolute left-0 mt-1 bg-white z-[9999] overflow-hidden"
                                                        style={{ minWidth: '220px', maxHeight: '320px', borderRadius: '10px', border: '1.5px solid #e0e8e3', boxShadow: '0 8px 24px rgba(26,92,50,0.10), 0 2px 8px rgba(0,0,0,0.06)' }}
                                                    >
                                                        <div style={{ padding: '8px 12px', borderBottom: '1px solid #f0f4f1', background: '#fafcfb' }}>
                                                            <div className="relative">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search users..."
                                                                    style={{ width: '100%', paddingLeft: '26px', paddingRight: '8px', paddingTop: '5px', paddingBottom: '5px', fontSize: '12px', border: '1.5px solid #e0e8e3', borderRadius: '6px', outline: 'none', background: '#fff' }}
                                                                    value={searchTermAssignee}
                                                                    onChange={(e) => setSearchTermAssignee(e.target.value)}
                                                                    autoFocus
                                                                />
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#9ca3af" className="absolute left-2 top-1/2 -translate-y-1/2" viewBox="0 0 16 16">
                                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                                </svg>
                                                            </div>
                                                        </div>

                                                        {Array.isArray(filter.value) && filter.value.length > 0 && (
                                                            <div style={{ padding: '5px 12px', borderBottom: '1px solid #e9f3ec', background: '#f0f9f2', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                <span style={{ fontSize: '11px', color: '#1a7d3e', fontWeight: 500 }}>{filter.value.length} selected</span>
                                                                <button type="button" onClick={() => updateFilter(index, { value: [] })} style={{ fontSize: '11px', color: '#1a7d3e', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 500 }}>
                                                                    Clear all
                                                                </button>
                                                            </div>
                                                        )}

                                                        {userOptions.length > 0 && (() => {
                                                            const selectedVals = Array.isArray(filter.value) ? filter.value : [];
                                                            const allSelected = userOptions.length > 0 && selectedVals.length === userOptions.length;
                                                            return (
                                                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', cursor: 'pointer', background: '#fafcfb', borderBottom: '1px solid #f0f4f1' }}>
                                                                    <input type="checkbox" checked={allSelected} onChange={() => { if (allSelected) { updateFilter(index, { value: [] }); } else { updateFilter(index, { value: propertyOptions }); } }} className="rounded border-gray-300 cursor-pointer" style={{ accentColor: '#1a7d3e' }} />
                                                                    <span style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>Select All</span>
                                                                </label>
                                                            );
                                                        })()}

                                                        <div className="overflow-y-auto" style={{ maxHeight: '170px', scrollbarWidth: 'thin', scrollbarColor: 'rgba(0,0,0,0.15) transparent' }}>
                                                            {(() => {
                                                                const filteredOptions = userOptions.filter(u => u.label.toLowerCase().includes(searchTermAssignee.toLowerCase()));
                                                                if (filteredOptions.length === 0) {
                                                                    return <div style={{ padding: '12px', fontSize: '12px', color: '#9ca3af', textAlign: 'center' }}>No users found</div>;
                                                                }
                                                                return filteredOptions.map((user) => {
                                                                    const selectedVals = Array.isArray(filter.value) ? filter.value : [];
                                                                    const isChecked = selectedVals.some((u) => u.value === user.value);
                                                                    return (
                                                                        <label key={user.value} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 12px', cursor: 'pointer', background: isChecked ? '#f0f9f2' : 'transparent', transition: 'background 0.12s ease' }}>
                                                                            <input type="checkbox" checked={isChecked} onChange={() => toggleAssigneeUser(index, user)} className="rounded cursor-pointer" style={{ accentColor: '#1a7d3e' }} />
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                                                                                <div style={{ width: '24px', height: '24px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '11px', fontWeight: 600, flexShrink: 0, background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)' }}>
                                                                                    {user.label.charAt(0).toUpperCase()}
                                                                                </div>
                                                                                <span style={{ fontSize: '13px', color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user.label}</span>
                                                                            </div>
                                                                        </label>
                                                                    );
                                                                });
                                                            })()}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : filter.field === 'customProperty' ? (
                                            <div className="relative flex-1" ref={propertyOpenIndex === index ? propertyDropdownRef : null}>
                                                <button
                                                    type="button"
                                                    onClick={() => setPropertyOpenIndex(propertyOpenIndex === index ? null : index)}
                                                    style={{
                                                        width: '100%',
                                                        height: '34px',
                                                        padding: '0 10px',
                                                        fontSize: '13px',
                                                        border: '1.5px solid #e0e8e3',
                                                        borderRadius: '8px',
                                                        background: '#fafcfb',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        cursor: 'pointer',
                                                        minWidth: '160px',
                                                        transition: 'border-color 0.15s ease',
                                                    }}
                                                >
                                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: Array.isArray(filter.value) && filter.value.length > 0 ? '#1a7d3e' : '#9ca3af', fontWeight: Array.isArray(filter.value) && filter.value.length > 0 ? 500 : 400 }}>
                                                        {Array.isArray(filter.value) && filter.value.length > 0
                                                            ? filter.value.length === propertyOptions.length
                                                                ? 'All selected'
                                                                : `${filter.value.length} selected`
                                                            : 'Select properties...'}
                                                    </span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="#9ca3af" viewBox="0 0 16 16" style={{ flexShrink: 0, marginLeft: '6px' }}>
                                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                    </svg>
                                                </button>

                                                {propertyOpenIndex === index && (
                                                    <div
                                                        className="absolute left-0 mt-1 bg-white z-[9999] overflow-hidden"
                                                        style={{ minWidth: '220px', maxHeight: '320px', borderRadius: '10px', border: '1.5px solid #e0e8e3', boxShadow: '0 8px 24px rgba(26,92,50,0.10), 0 2px 8px rgba(0,0,0,0.06)' }}
                                                    >
                                                        <div style={{ padding: '8px 12px', borderBottom: '1px solid #f0f4f1', background: '#fafcfb' }}>
                                                            <div className="relative">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search properties..."
                                                                    style={{ width: '100%', paddingLeft: '26px', paddingRight: '8px', paddingTop: '5px', paddingBottom: '5px', fontSize: '12px', border: '1.5px solid #e0e8e3', borderRadius: '6px', outline: 'none', background: '#fff' }}
                                                                    value={searchTermProperty}
                                                                    onChange={(e) => setSearchTermProperty(e.target.value)}
                                                                    autoFocus
                                                                />
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#9ca3af" className="absolute left-2 top-1/2 -translate-y-1/2" viewBox="0 0 16 16">
                                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                                </svg>
                                                            </div>
                                                        </div>

                                                        {Array.isArray(filter.value) && filter.value.length > 0 && (
                                                            <div style={{ padding: '5px 12px', borderBottom: '1px solid #e9f3ec', background: '#f0f9f2', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                <span style={{ fontSize: '11px', color: '#1a7d3e', fontWeight: 500 }}>{filter.value.length} selected</span>
                                                                <button type="button" onClick={() => updateFilter(index, 'value', [])} style={{ fontSize: '11px', color: '#1a7d3e', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 500 }}>
                                                                    Clear all
                                                                </button>
                                                            </div>
                                                        )}

                                                        {propertyOptions.length > 0 && (() => {
                                                            const selectedVals = Array.isArray(filter.value) ? filter.value : [];
                                                            const allSelected = propertyOptions.length > 0 && selectedVals.length === propertyOptions.length;
                                                            return (
                                                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', cursor: 'pointer', background: '#fafcfb', borderBottom: '1px solid #f0f4f1' }}>
                                                                    <input type="checkbox" checked={allSelected} onChange={() => { if (allSelected) { updateFilter(index, 'value', []); } else { updateFilter(index, 'value', propertyOptions); } }} className="rounded cursor-pointer" style={{ accentColor: '#1a7d3e' }} />
                                                                    <span style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>Select All</span>
                                                                </label>
                                                            );
                                                        })()}

                                                        <div className="overflow-y-auto" style={{ maxHeight: '170px', scrollbarWidth: 'thin', scrollbarColor: 'rgba(0,0,0,0.15) transparent' }}>
                                                            {(() => {
                                                                const filteredOptions = propertyOptions.filter(p => p.label.toLowerCase().includes(searchTermProperty.toLowerCase()));
                                                                if (filteredOptions.length === 0) {
                                                                    return <div style={{ padding: '12px', fontSize: '12px', color: '#9ca3af', textAlign: 'center' }}>No properties found</div>;
                                                                }
                                                                return filteredOptions.map((property) => {
                                                                    const selectedVals = Array.isArray(filter.value) ? filter.value : [];
                                                                    const isChecked = selectedVals.some((p) => p.value === property.value);
                                                                    return (
                                                                        <label key={property.value} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 12px', cursor: 'pointer', background: isChecked ? '#f0f9f2' : 'transparent', transition: 'background 0.12s ease' }}>
                                                                            <input type="checkbox" checked={isChecked} onChange={() => toggleProperty(index, property)} className="rounded cursor-pointer" style={{ accentColor: '#1a7d3e' }} />
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                                                                                <div style={{ width: '24px', height: '24px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '11px', fontWeight: 600, flexShrink: 0, background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)' }}>
                                                                                    {property.label.charAt(0).toUpperCase()}
                                                                                </div>
                                                                                <span style={{ fontSize: '13px', color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{property.label}</span>
                                                                            </div>
                                                                        </label>
                                                                    );
                                                                });
                                                            })()}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                style={{ height: '34px', padding: '0 10px', fontSize: '13px', border: '1.5px solid #e0e8e3', borderRadius: '8px', background: '#fafcfb', outline: 'none', flex: 1, color: '#1f2937', transition: 'border-color 0.15s ease' }}
                                                value={localFilterValues[index] ?? ''}
                                                onChange={(e) => setLocalFilterValues({ ...localFilterValues, [index]: e.target.value })}
                                                onKeyDown={(e) => handleFilterKeyDown(e, index)}
                                                onBlur={() => handleFilterBlur(index)}
                                                placeholder="Enter value"
                                            />
                                        )}

                                        {/* Remove filter */}
                                        <button
                                            onClick={() => removeFilter(index)}
                                            title="Remove filter"
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30px', height: '30px', borderRadius: '7px', border: '1.5px solid #fcd5d5', background: '#fff5f5', color: '#ef4444', cursor: 'pointer', flexShrink: 0, transition: 'all 0.15s ease' }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 5h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7H6v7a.5.5 0 0 1-1 0v-7z" />
                                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2H5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3a.5.5 0 0 0-.5.5V4h12v-.5a.5.5 0 0 0-.5-.5h-11z" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}

                                {/* Divider */}
                                {filters.length > 0 && (
                                    <div style={{ height: '1px', background: '#f0f4f1', margin: '4px 0 10px' }} />
                                )}

                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '4px' }}>
                                    {/* Add filter */}
                                    <button
                                        onClick={addFilter}
                                        style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12.5px', fontWeight: 500, color: '#1a7d3e', background: 'none', border: 'none', cursor: 'pointer', padding: '0', transition: 'color 0.15s ease' }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                        </svg>
                                        Add filter
                                    </button>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {/* Reset */}
                                        <button
                                            onClick={resetFilters}
                                            style={{ fontSize: '12.5px', fontWeight: 600, color: '#374151', background: '#ffffff', border: '1.5px solid #e0e8e3', borderRadius: '7px', padding: '6px 16px', cursor: 'pointer', transition: 'background 0.15s ease' }}
                                        >
                                            Reset
                                        </button>

                                        {/* Apply */}
                                        <button
                                            onClick={applyFilters}
                                            style={{ fontSize: '12.5px', fontWeight: 600, color: '#ffffff', background: '#1a7d3e', border: 'none', borderRadius: '7px', padding: '6px 16px', cursor: 'pointer', transition: 'background 0.15s ease' }}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {(role === 'admin' || (boardName && boardName.length > 0)) && (
                            <div
                                className="board-selector-wrapper"
                                onClick={() => setIsOpenDeadline(false)}
                            >
                                    {(() => {
                                        const options = boardName ? [...boardName] : [];
                                        if (hasArchiveAccess) {
                                            options.unshift({ label: 'Archive', value: 'archived' });
                                        }
                                        return (
                                            <Select
                                                className="cursor-pointer"
                                                style={{ width: '150px' }}
                                                options={options}
                                                value={selectedBoard}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                    }),
                                                }}
                                                onChange={(e) => {
                                                    if (e.value === 'archived') {
                                                        navigate('/archivedboard', { state: { boardName: boardName } });
                                                        setSelectedBoard(e);
                                                        return;
                                                    }
                                                    setSelectedBoardId(e?.value);
                                                    setLocalStorageItem('boardId', e?.value)
                                                    // handleSelectedBoard(e);
                                                    setSelectedBoard(e);
                                                    setIsOpenDeadline(false);

                                                    setBoardName((prev) => {
                                                        const rest = prev.filter((b) => b.value !== e.value);
                                                        return [e, ...rest];
                                                    });
                                                }}
                                                components={{
                                                    Option: ({ data, innerRef, innerProps }) => (
                                                        <div
                                                            ref={innerRef}
                                                            {...innerProps}
                                                            className='label-board'
                                                        >
                                                            <span
                                                                className='label-span'
                                                                title={data.label}
                                                            >
                                                                {data.label}
                                                            </span>
                                                        </div>
                                                    ),
                                                }}
                                            />

                                        );
                                    })()}
                            </div>
                        )}

                    </div>
                )}
                <div className="flex items-center gap-4" style={{ alignSelf: 'center' }}>
                    <div className="flex flex-col items-center mx-2">
                        {showMenuButton && (
                            <div
                                ref={settingsBtnRef}
                                className="settings-btn"
                                onClick={() => {
                                    logoutdropdown(), setIsOpenDeadline(false);
                                }}
                            >

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-gear"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
                                    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
                                </svg>
                            </div>
                        )}
                    </div>
                </div>
            </div >
            {boardStatus && (
                <AddBoardModal
                    show={boardStatus}
                    onHide={() => setBoardStatus(false)}
                    getAllBoard={getAllBoard}
                    setBoardName={setBoardName}
                />
            )
            }
            {
                columnAddStatus && (
                    <AddColumnModal
                        show={columnAddStatus}
                        onHide={() => setColumnAddStatus(false)}
                        handleAddColumn={handleAutomation}
                    />
                )
            }
            {
                automtStatus && (
                    <AddAutoMation
                        show={automtStatus}
                        onHide={() => setAutomtStatus(false)}
                        handleAddColumn={handleAutomation}
                        selectedBoard={selectedBoard}
                        getTaskMailIndbox={getTaskMailIndbox}
                    />
                )
            }
            <div>
                {automations && step === 1 && (
                    <AllAutomation
                        show={automations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        step={step}
                        setStep={setStep}
                        setAutomations={setAutomations}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
                {automations && step === 2 && (
                    <Automations
                        show={automations}
                        setAutomations={setAutomations}
                        onHide={() => {
                            setAutomations(false);
                            setStep(1);
                        }}
                        boardName={boardName}
                        gmailUsers={filterList}
                        step={step}
                        setStep={setStep}
                        editId={editId}
                        setEditId={setEditId}
                    />
                )}
            </div>
            {
                deleteShowBox && (
                    <ConfirmationPopup
                        taskToDeleteId={''}
                        onCancel={() => {
                            setDeleteShowBox(false);
                        }}
                        deleteTaskMail={handleDelete}
                    />
                )
            }
            {<Notification isNotificationOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} />}
        </>
    );
};

export default Header;
